import { useEffect, useState } from "react";
import LegalHeader from "src/Candidate/organisms/LegalHeader";
import LegalPolicyContent from "src/Candidate/molecules/LegalPolicyContent";
import { getCookiePolicy } from "src/services/apiCalls/legal";
import {
  Section,
  LegalPageData,
} from "src/Candidate/molecules/LegalPolicyContent/LegalPolicyContent.types";
import HomeHeader from "./seoComponent";

export default function Cookies(): JSX.Element {
  const [sections, setSections] = useState<Section[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [lastUpdated, setLastUpdated] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response: LegalPageData = await getCookiePolicy();
        const mapped: Section[] = (response.subsections ?? []).map((sub) => ({
          heading: sub.title,
          content: sub.contents.map((c) => c.content),
        }));
        setSections(mapped);
        setLastUpdated(response.last_updated ?? null);
      } catch (err: any) {
        setError(err.message || "Failed to load cookie policy");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <HomeHeader title="Cookies" />
      <div className="relative overflow-y-auto max-h-[calc(100vh - 11rem)] sm:max-h-[calc(100vh - 8rem)]">
        <LegalHeader />

        <LegalPolicyContent
          sections={sections}
          loading={loading}
          error={error}
          lastUpdated={lastUpdated}
        />
      </div>
    </>
  );
}
